import React from 'react'
import { Breadcrumbs, MetaSeo } from '../..'
import MyImage from '../../atoms/MyImage/MyImage'
import useTrans from '../../../hooks/useTrans'
import ServiceGiftCard from '../../molecules/ServiceGiftCard/ServiceGiftCard'
import { getAltText } from '../../../utils/safe'

const ServiceGiftTemplate = ({ page }) => {
  const t = useTrans()
  return (
    <div className="page service-gift-template">
      <MetaSeo seo={page.seo} />
      <div className="service-gift-template">
        <div className="w-container">
          <Breadcrumbs breadcrumbs={page.breadcrumbs} />
          <h1 className="page__title">{t('Service Gift')}</h1>
        </div>

        <div className="service-gift-header">
          <div className="service-gift-header__image-box">
            <MyImage
              src={page.main_image?.url}
              alt={getAltText(page.main_image)}
              width={610}
              height={290}
              layout="responsive"
            />
          </div>

          <div className="service-gift-header__content">
            <h3 className="service-gift-header__title">{t("Che cos'è")}</h3>
            <p>
              {t(
                'Il service Gift è il servizio che ti permette di usufruire gratuitamente di un sito Web, ' +
                  'costantemente aggiornato con i prodotti del catalogo Sipec, le disponibilita, ' +
                  'i prezzi e le descrizioni degli articoli.'
              )}
            </p>
            <p></p>
            <p>{t("Richiedi subito l'attivazione!")}</p>
          </div>
        </div>
        <div className="service-gift-attivazione">
          <h3 className="service-gift-attivazione__title">
            {t('Attiva subito il Service Gift che fa per te')}
          </h3>
          <div className="service-gift-attivazione__cards">
            <ServiceGiftCard
              title={t('Service Gift sito vetrina')}
              description={t('Service Gift sito vetrina DESCRIZIONE')}
              cta={t('Richiedi attivazione')}
              link="/richiesta-attivazione"
            />
            <ServiceGiftCard
              title={t('Service Gift sito e-commerce')}
              description={t('Service Gift sito e-commerce DESCRIZIONE')}
              cta={t('Richiedi attivazione')}
              link="/richiesta-attivazione"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ServiceGiftTemplate
